import { Directive, ElementRef, HostListener, signal, inject, output } from '@angular/core';

@Directive({
	standalone: true,
	selector: '[appDetectValueChangeOnFocusOut]',
})
export class DetectValueChangeOnFocusOutDirective {
	initialValue = signal<string | null>(null);

	valueChangeOnFocusOut = output<string>();

	private readonly el: ElementRef = inject(ElementRef);

	@HostListener('focus') onFocus(): void {
		this.initialValue.set(this.getInputValue());
	}

	@HostListener('focusout') onFocusOut(): void {
		const currentValue = this.getInputValue();
		if (this.initialValue !== null && currentValue !== this.initialValue()) {
			this.valueChangeOnFocusOut.emit(currentValue);
		}
	}

	private getInputValue(): string {
		return this.el.nativeElement.value;
	}
}
